import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { clickContinueEWalletModalSf, checkoutRedirectToCheckoutFromExpressCheckout } from '@wix/bi-logger-ec-site/v2';
export const createOOIPlatformSiteBILogger = function (biToken, defaults, biLogger) {
  if (defaults === void 0) {
    defaults = {};
  }
  return biLogger.updateDefaults({
    ...defaults,
    bi_token: biToken
  }).logger();
};
export class BIService {
  constructor(controllerConfig) {
    var _controllerConfig$pla, _controllerConfig$pla2;
    _defineProperty(this, "logger", void 0);
    const loggerFactory = controllerConfig.platformAPIs.biLoggerFactory == null ? void 0 : controllerConfig.platformAPIs.biLoggerFactory();
    if (!loggerFactory) {
      return;
    }
    this.logger = fixOldLoggerFactoryDueToWorkerYoshiV4(loggerFactory).updateDefaults({
      bi_token: (_controllerConfig$pla = controllerConfig.platformAPIs.bi) == null ? void 0 : _controllerConfig$pla.biToken,
      appName: 'Express Checkout',
      _msid: (_controllerConfig$pla2 = controllerConfig.platformAPIs.bi) == null ? void 0 : _controllerConfig$pla2.metaSiteId
    }).logger();
  }
  clickContinueEWalletModalSf(checkoutId, cartId) {
    void this.logger.report(clickContinueEWalletModalSf({
      cartId,
      checkoutId
    }));
  }
  reportNavigateToFastFlowCheckout(_ref) {
    let {
      checkoutId,
      cartId,
      purchaseFlowId,
      reason
    } = _ref;
    void this.logger.report(checkoutRedirectToCheckoutFromExpressCheckout({
      cartId,
      checkoutId,
      purchaseFlowId,
      reason
    }));
  }
}
function fixOldLoggerFactoryDueToWorkerYoshiV4(factory) {
  if (factory.factory) {
    return factory.factory();
  }
  return factory;
}
//# sourceMappingURL=BIService.js.map